import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBusinessStore } from '../store/useBusinessStore';
import { isModuleEnabled } from '../utils/businessConfigHelpers';

// El menú tiene una sola entrada «Catálogo y precios»; dentro, estas pestañas llevan a las dos pantallas: los servicios o el menú
// (lo que atiende el bot) y las listas de precios del catálogo (cotizaciones). Sin el módulo del catálogo no se muestra nada.
export default function ProductsTabs() {
  const { pathname } = useLocation();
  const { masterDb, activeBusinessId } = useBusinessStore();
  const business = (Array.isArray(masterDb) ? masterDb : []).find((b) => String(b.id) === String(activeBusinessId));
  if (!isModuleEnabled(business, 'feature_catalogo')) return null;
  const isRestaurant = (business?.tipo_negocio || '').toLowerCase().includes('restaurante');
  const tabs = [
    { to: '/v2/servicios', label: isRestaurant ? 'Menú y carta' : 'Servicios y precios' },
    { to: '/v2/catalogo', label: 'Productos y listas de precios' }
  ];
  return (
    <div role="tablist" aria-label="Catálogo y precios" className="flex flex-wrap gap-2">
      {tabs.map((t) => {
        const active = pathname === t.to;
        return (
          <Link key={t.to} to={t.to} role="tab" aria-selected={active}
            className={`px-4 py-2 rounded-xl text-xs font-bold border transition-colors ${active ? 'bg-seryi-green/10 text-seryi-green border-seryi-green/30' : 'border-seryi-bg-light text-seryi-text hover:text-seryi-heading'}`}>
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
